// Staging environment — deployed at payment.stage.tsin.ca (TSIN account, 483382415631)
// Environnement de pré-production — déployé sur payment.stage.tsin.ca (compte TSIN, 483382415631)
export const environment = {
  production: false,

  // Payment API — staging backend (payment.api.stage.tsin.ca)
  // API Payment — backend de pré-production (payment.api.stage.tsin.ca)
  apiUrl: 'https://payment.api.stage.tsin.ca/api',

  // Payment frontend self-reference (used for CORS / redirect targets)
  // Référence propre au frontend Payment (utilisée pour CORS / redirections)
  paymentUrl: 'https://payment.stage.tsin.ca',

  // Auth service (PRO account) / Service d'authentification (compte PRO)
  userBaseUrl: 'https://auth.api.stage.tsin.ca/api',
  userMgtUrl: 'https://auth.stage.tsin.ca/auth/login',
  userBaseUrlFallback: 'https://auth.api.stage.tsin.ca/api',
  userBaseMgtUrlFallback: 'https://auth.stage.tsin.ca/auth/login',

  // Exams portal / Portail des examens
  examUrl: 'https://exams.stage.tsin.ca/',
  examOldUrl: 'https://exams.stage.tsin.ca/',
  examOldBaseUrl: 'https://exams.api.stage.tsin.ca/api',

  // Learning platform / Plateforme d'apprentissage
  learningUrl: 'https://learning.stage.tsin.ca/',
  learningBaseUrl: 'https://learning.api.stage.tsin.ca/api',

  salt: 'ZC\f?.Kp[jnhXf3-"<f3{/tZS@#~(8on',
  paymentMode: 'qa',
  paymentTimeLimitInMs: 180000,
};
